import { render, staticRenderFns } from "./BuyReportProductAndSuppliers.vue?vue&type=template&id=732f0c54&"
import script from "./BuyReportProductAndSuppliers.vue?vue&type=script&lang=js&"
export * from "./BuyReportProductAndSuppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports